import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=46d6704f&scoped=true&"
import script from "./CreateOrganization.vue?vue&type=script&lang=js&"
export * from "./CreateOrganization.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganization.vue?vue&type=style&index=0&id=46d6704f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6704f",
  null
  
)

export default component.exports